/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:12:50
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:59:51
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import {
  COMPLETE_RECHARGES_LIST, SET_RECHARGES_TERMS,
} from './mutation-types';

export default {
  [SET_RECHARGES_TERMS](state, payload) {
    const _state = state;
    _state.rechargesList.terms = payload.terms;
  },
  [COMPLETE_RECHARGES_LIST](state, payload) {
    const _state = state;
    _state.rechargesList.data = payload.rechargesList;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Recharges/mutations.js